<script>
  import MenuBar from "../../../components/menuBar/MenuBar.svelte";
  import MenuBarItem from "../../../components/menuBar/MenuBarItem.svelte";
  import FilterInput_ProductionOrder from "../../../components/input/FilterInput_ProductionOrder.svelte";
  import FilterDialog2_ProductionOrder from "../../../components/filter/FilterDialog2_ProductionOrder.svelte";
  import ToggleSwitch from "../../../components/input/ToggleSwitch.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import { onMount, onDestroy } from 'svelte';
  import { Filters } from "./stores.js";
  import dayjs from "dayjs";

  export let filter_year;
  export let filter_month;
  export let filter_process;
  export let filter_taseiban;
  export let filter_Work_OrderItem;
  export let filter_order;
  export let filter_completed;

  export let option_years;
  export let option_months;
  export let option_processes;
  export let option_taseibans;
  export let option_Work_OrderItems;
  export let option_orders;
  export let option_completed_strs;
  export let refresh;

  let checked_years = [];
  let checked_months = [];
  export let checked_processes = [];
  let checked_taseiban = [];
  let checked_Work_OrderItems = [];
  let checked_orders = [];
  let checked_completed = [];

  const current_datetime = dayjs();
  const applyPreloadedSettings = (options, preload) => {
    if (!preload || preload.length === 0) return options;

    return options.map((obj) => {
      if (preload.includes(obj.text)) {
        return { ...obj, excluded: true };
      }
      return obj;
    });
  };

  if (filter_year && filter_year.length < option_years.length) {
    option_years = applyPreloadedSettings(option_years, filter_year);
    Filters.update(filters => {
      filters["YearFilter"].items = option_years;
      return filters;
    });
  } else {
    filter_year = option_years.filter(option => option.text !== current_datetime.format("YYYY")).map(option => option.text);
    option_years = applyPreloadedSettings(option_years, filter_year);
    Filters.update(filters => {
      filters["YearFilter"].items = option_years;
      return filters;
    });
  }
  checked_years = option_years.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
  if (filter_month && filter_month.length < option_months.length) {
    option_months = applyPreloadedSettings(option_months, filter_month);
    Filters.update(filters => {
      filters["MonthFilter"].items = option_months;
      return filters; 
    });
  } else {
    filter_month = option_months.filter(option => option.text !== current_datetime.format("M")).map(option => option.text);
    option_months = applyPreloadedSettings(option_months, filter_month);
    Filters.update(filters => {
      filters["MonthFilter"].items = option_months;
      return filters; 
    });
  }
  checked_months = option_months.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
  if (filter_process) {
    option_processes = applyPreloadedSettings(option_processes, filter_process);
    Filters.update(filters => {
      filters["ProcessFilter"].items = option_processes;
      return filters; 
    });
  }
  checked_processes = option_processes.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
  if (filter_taseiban) {
    option_taseibans = applyPreloadedSettings(option_taseibans, filter_taseiban);
    Filters.update(filters => {
      filters["TaseibanFilter"].items = option_taseibans;
      return filters; 
    });
  }
  checked_taseiban = option_taseibans.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
  
  if (filter_Work_OrderItem) {
    option_Work_OrderItems = applyPreloadedSettings(option_Work_OrderItems, filter_Work_OrderItem);
    Filters.update(filters => {
      filters["WorkOrderItemFilter"].items = option_Work_OrderItems;
      return filters; 
    });
  }
  checked_Work_OrderItems = option_Work_OrderItems.filter((item) => !item.excluded && item.displayed).map((item) => item.text);

  if (filter_order) {
    option_orders = applyPreloadedSettings(option_orders, filter_order);
    Filters.update(filters => {
      filters["OrderFilter"].items = option_orders;
      return filters; 
    });
  }
  checked_orders = option_orders.filter((item) => !item.excluded && item.displayed).map((item) => item.text);

/*   if (filter_completed) {
    option_completed_strs = applyPreloadedSettings(option_completed_strs, filter_completed);
    Filters.update(filters => {
      filters["CompletedFilter"].items = option_completed_strs;
      return filters; 
    });
  }
  checked_completed = option_completed_strs.filter((item) => !item.excluded && item.displayed).map((item) => item.text); */

  // Reactive statement to set the `items` variable dynamically based on `target`
  let items = [];

  $: {
    if (target === "加工年") items = option_years.sort((a, b) => Number(a.text) - Number(b.text));
    else if (target === "加工月") items = option_months.sort((a, b) => Number(a.text) - Number(b.text));
    else if (target === "製番") items = option_taseibans.sort((a, b) => a.text.localeCompare(b.text));
    else if (target === "工程") items = option_processes.sort((a, b) => a.text.localeCompare(b.text));
    else if (target === "品番") items = option_Work_OrderItems.sort((a, b) => a.text.localeCompare(b.text));
    else if (target === "オーダ") items = option_orders.sort((a, b) => Number(a.text) - Number(b.text));
    else if (target === "完了品/未完了品") items = option_completed_strs.sort((a, b) => a.text.localeCompare(b.text));
  }

  $: {
    filter_year = option_years.filter((item) => item.excluded).map((item) => item.text);
    checked_years = option_years.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
    filter_month = option_months.filter((item) => item.excluded).map((item) => item.text);
    checked_months = option_months.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
    filter_process = option_processes.filter((item) => item.excluded).map((item) => item.text);
    checked_processes = option_processes.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
    filter_taseiban = option_taseibans.filter((item) => item.excluded).map((item) => item.text);
    checked_taseiban = option_taseibans.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
    filter_Work_OrderItem = option_Work_OrderItems.filter((item) => item.excluded).map((item) => item.text);
    checked_Work_OrderItems = option_Work_OrderItems.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
    filter_order = option_orders.filter((item) => item.excluded).map((item) => item.text);
    checked_orders = option_orders.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
    filter_completed = option_completed_strs.filter((item) => item.excluded).map((item) => item.text);
    checked_completed = option_completed_strs.filter((item) => !item.excluded && item.displayed).map((item) => item.text);
  }

  let autoUpdate = true;
  let autoUpdateInterval = null;

  let isFilterDialogOpen = false;
  let target;
  function toggleFilterDialog(title) {
    target = title;
    isFilterDialogOpen = !isFilterDialogOpen;
  }

  function removeAutoUpdateInterval() {
    if (autoUpdateInterval !== null) {
      clearInterval(autoUpdateInterval);
      autoUpdateInterval = null;
    }
  }

  function queryFilterDetermined(resultItems, filteredItems, originalOptionTexts) {
    const remainedItemTexts = new Set(filteredItems.filter(item => !item.excluded).map(item => item.text));
    for (const item of resultItems) {
      if (originalOptionTexts.has(item.text) && !remainedItemTexts.has(item.text)) {
        item.excluded = true;
      }
    }
    filterDetermined(resultItems);
  }
  function filterDetermined(resultItems) {
    if (target === "加工年") {
      /* option_years = items; */
      Filters.update(filters => {
        filters["YearFilter"].items = resultItems;
        return filters; 
      });
    } else if (target === "加工月") {
      Filters.update(filters => {
        filters["MonthFilter"].items = resultItems;
        return filters; 
      });
    } else if (target === "製番") {
      Filters.update(filters => {
        filters["TaseibanFilter"].items = resultItems;
        return filters; 
      });  
    } else if (target === "工程") {
      Filters.update(filters => {
        filters["ProcessFilter"].items = resultItems;
        return filters; 
      });
    } else if (target === "品番") {
      Filters.update(filters => {
        filters["WorkOrderItemFilter"].items = resultItems;
        return filters; 
      });
    } else if (target === "オーダ") {
      Filters.update(filters => {
        filters["OrderFilter"].items = resultItems;
        return filters; 
      });
    } else if (target === "完了品/未完了品") {
      Filters.update(filters => {
        filters["CompletedFilter"].items = resultItems;
        return filters;
      });
    }
  }

  onMount(() => {
    if (autoUpdate === true) {
      autoUpdateInterval = setInterval(refresh, 10000);
    }
    else {
      removeAutoUpdateInterval();
    }
  });

  onDestroy(() => {
    removeAutoUpdateInterval();
  });
</script>

<MenuBar>
  <svelte:fragment slot="settings">
    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="加工年"
          bind:query={checked_years}
          option_length={option_years.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>
  
    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="加工月"
          bind:query={checked_months}
          option_length={option_months.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>
  
    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="製番"
          bind:query={checked_taseiban}
          option_length={option_taseibans.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>

    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="工程"
          bind:query={checked_processes}
          option_length={option_processes.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>

    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="品番"
          bind:query={checked_Work_OrderItems}
          option_length={option_Work_OrderItems.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>
  
    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="オーダ"
          bind:query={checked_orders}
          option_length={option_orders.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>

    <MenuBarItem>
      <div class="filter-input-container">
        <FilterInput_ProductionOrder
          title="完了品/未完了品"
          bind:query={checked_completed}
          option_length={option_completed_strs.length}
          onClickShowDialog={toggleFilterDialog}
        />
      </div>
    </MenuBarItem>
    
  </svelte:fragment>
  <MenuBarItem slot="pagination">
    <ToggleSwitch
      bind:on={autoUpdate}
      onChange={(e) => {
        if (e.target.checked) {
          autoUpdateInterval = setInterval(refresh, 10000);
        }
        else {
          if (autoUpdateInterval !== null) {
            clearInterval(autoUpdateInterval);
            autoUpdateInterval = null;
          }
        }
      }}
      label={translate("generic.autoUpdate")}
    />
  </MenuBarItem>
</MenuBar>

{#if isFilterDialogOpen}
  <FilterDialog2_ProductionOrder
    target={target}
    onFilterDetermined={(resultItems, filteredItems, query, originalOptionTexts) => {
      if (query && filteredItems.length !== 0) {
        queryFilterDetermined(resultItems, filteredItems, originalOptionTexts);
      } else {
        filterDetermined(resultItems);
      }
      isFilterDialogOpen = false;
    }}
    onClose={() => isFilterDialogOpen = false}
    bind:items={items}
  />
{/if}

<style>
  :global(.menubar-main) {
    position: relative;
    padding-bottom: 8px;
  }

  :global(.pagination-container) {
    margin-right: 16px;
  }

  :global(.nowrap) {
    font-size: 12px;
  }
</style>